import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
  },
  chartContainer: {
    width: '100%',
  },
  percentageBars: {
    paddingTop: theme.spacing(1),
  },
}));

export default useStyles;
